/* INTEGY V769 — visit-to-visit rotating merchandising.
   Liquid renders trustworthy, published Shopify product cards first.
   No API crawl, external scripts, or changes to collection/search indexes.
   The first N items remain available when scripts are blocked. */
(function () {
  'use strict';
  var selector = '[data-integy-visit-rotation]';
  function randomIndex(max) {
    if (max <= 1) return 0;
    if (window.crypto && window.crypto.getRandomValues) {
      var a = new Uint32Array(1);
      window.crypto.getRandomValues(a);
      return a[0] % max;
    }
    return Math.floor(Math.random() * max);
  }
  function shuffle(cards) {
    for (var i = cards.length - 1; i > 0; i--) {
      var j = randomIndex(i + 1);
      var t = cards[i]; cards[i] = cards[j]; cards[j] = t;
    }
  }
  function init(section) {
    if (!section || section.getAttribute('data-integy-visit-ready') === 'true') return;
    var track = section.querySelector('[data-integy-new-track],[data-integy-carousel-track]');
    if (!track) return;
    var candidates = Array.prototype.filter.call(track.children, function (el) {
      return el.nodeType === 1 && el.hasAttribute('data-integy-rotation-card');
    });
    if (!candidates.length) return;
    var visible = Math.min(candidates.length,
      Math.max(1,parseInt(section.getAttribute('data-integy-rotation-show') || '8',10)||8));
    var key = 'integy-v769-visit-' + section.getAttribute('data-integy-visit-rotation');
    var previous = '';
    try { previous = localStorage.getItem(key) || ''; } catch (_) {}
    if (candidates.length > 1) {
      shuffle(candidates);
      if (candidates[0].getAttribute('data-integy-rotation-key') === previous) {
        var swapIndex = 1 + randomIndex(candidates.length - 1);
        var first = candidates[0];
        candidates[0] = candidates[swapIndex];
        candidates[swapIndex] = first;
      }
    }
    /* V769 audit: prefer different product families in New Arrivals, rather
       than filling 32 slots with several colors of the same base SKU.
       Never alter the collection carousels' own merchandising order rules. */
    var chosen = [];
    var seenFamilies = Object.create(null);
    function familyFor(card) {
      var label = card.querySelector('.integy-new-arrivals__sku');
      var sku = label ? (label.textContent || '').replace(/^\s*SKU\s*:\s*/i,'').trim().toUpperCase() : '';
      if (!sku) return card.getAttribute('data-integy-rotation-key') || '';
      return sku.replace(/(?:BLACKSILVER|BLACKPURPLE|BLACKGOLD|BLACKRED|LIGHTBLUE|DARKGREEN|SILVER|YELLOW|ORANGE|PURPLE|BRONZE|CARBON|GREEN|BLACK|WHITE|BLUE|GREY|GRAY|RED|GUN)$/i, '');
    }
    if (section.hasAttribute('data-integy-new')) {
      candidates.forEach(function(card) {
        var family = familyFor(card);
        if (chosen.length >= visible || seenFamilies[family]) return;
        seenFamilies[family] = true;
        chosen.push(card);
      });
    }
    candidates.forEach(function(card) {
      if (chosen.length < visible && chosen.indexOf(card) < 0) chosen.push(card);
    });
    if (chosen.length > 1 && chosen[0].getAttribute('data-integy-rotation-key') === previous) {
      var chosenSwap = 1 + randomIndex(chosen.length - 1);
      var selectedFirst = chosen[0];
      chosen[0] = chosen[chosenSwap];
      chosen[chosenSwap] = selectedFirst;
    }
    var fragment = document.createDocumentFragment();
    chosen.forEach(function (card) {
      card.hidden = false;
      fragment.appendChild(card);
    });
    // Trim only this homepage section's candidate rail; never touch product
    // listings, filters, inventory or actual Shopify cart/price data.
    track.replaceChildren(fragment);
    track.scrollLeft = 0;
    section.setAttribute('data-integy-visit-ready', 'true');
    section.setAttribute('data-integy-rotation-selected', String(chosen.length));
    try { localStorage.setItem(key,chosen[0].getAttribute('data-integy-rotation-key')||''); } catch (_) {}
    track.dispatchEvent(new Event('scroll'));
  }
  function initAll(root) {
    if (root.matches && root.matches(selector)) init(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(init);
  }
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, {once:true});
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) initAll(event.target);
  });
})();